module.exports = "/images/offline.svg?5923f953cf7106fb3f987bfa9f51f01a";